{
  "unit": {
    "kwh": "kWh",
    "du": "度",
    "du_hint": "1 度 = 1 kWh"
  },
  "fmt": {
    "less_than": "不到 {{v}}",
    "approx": "約 {{v}}"
  },
  "cmp": {
    "flat": "持平",
    "more_pct": "多 {{pct}}%",
    "less_pct": "少 {{pct}}%",
    "more_abs": "多 {{v}}",
    "less_abs": "少 {{v}}",
    "why_prev_coverage": "上一期同期資料完整度 {{pct}}%，不到 90%，不比較",
    "why_meters_changed": "量測點跟上一期不同（新增或移除），不比較",
    "why_prev_small": "上一期不到 1 度，改寫差多少",
    "why_unavailable": "讀不到，不比較",
    "why_no_prev": "上一期沒有資料，不比較",
    "why_btn": "為什麼沒有比較"
  },
  "q": {
    "measured": "實測",
    "estimated": "補估",
    "incomplete": "沒有資料"
  },
  "chart": {
    "numbers": "看數字",
    "group": "{{title}}（左右鍵逐格看）",
    "legend_bar": "實測",
    "legend_est": "補估",
    "legend_miss": "沒有資料（不是 0）",
    "legend_live": "進行中",
    "legend_zero": "實測 0",
    "col_time": "時間",
    "col_quality": "資料品質",
    "total": "合計",
    "prev_day": "前一天",
    "next_day": "下一天",
    "prev_cell": "前一格",
    "next_cell": "下一格",
    "say_day": "{{label}}，{{v}}，{{q}}",
    "say_live": "{{label}}，{{v}}，進行中（到 {{time}}）",
    "say_miss": "{{label}}，沒有資料",
    "day_label": "{{m}} 月 {{d}} 日",
    "hour_label": "{{h}} 時",
    "month_label": "{{m}} 月",
    "tz_note": "以 {{tz}} 顯示；每日合計依各$t(translation:leaf.cur)當地日期"
  },
  "meter": {
    "poe_powered": "{{station}} · 第 {{port}} 孔供電",
    "port": "{{station}} 第 {{port}} 孔",
    "port_of_home": "{{home}} {{station}} 第 {{port}} 孔",
    "unmatched": "沒有對到設備"
  },
  "kind": {
    "plug": "插座",
    "poe": "PoE 供電",
    "meter": "電表"
  },
  "title": "用電",
  "subtitle": "會回報用電的設備花了多少電、大概多少錢",
  "tab": {
    "overview": "總覽",
    "ranking": "用電排行",
    "report": "報表"
  },
  "settings_btn": "用電設定",
  "settings_pick": "選擇要設定的$t(translation:leaf.cur)",
  "no_access_page": "只有能看用電的人能開這頁",
  "empty": "{{scope}}沒有會回報用電的設備。會回報的有：{{brand}}插座、有 PoE 供電明細的 Kinio Station、經{{brand}}中樞連進來的 Matter 插座 / 電表。",
  "empty_all": "切到全部",
  "load_err": "讀不到用電資料（{{reason}}）",
  "retry": "重試",
  "partial_err": "有些組織的用電資料讀不到，下面只算讀得到的",
  "mock_banner": "示意資料：用電 API 還沒上這個環境，畫面用假資料",
  "first_notice": "第一次開用電頁：用電資料只給能看用電的人看；量到的是插座、PoE 供電與電表，不是整個$t(translation:leaf.cur)的總用電。",
  "dismiss": "知道了",
  "period": {
    "month_to_date": "本月到今天",
    "last_month": "上個月",
    "today": "今天",
    "week": "本週到今天",
    "year": "今年到今天"
  },
  "need": {
    "title": "需要處理",
    "count": "{{n}} 項",
    "count_shown": "{{n}} 項 · 顯示 {{shown}} 項",
    "show_all": "看全部 {{n}} 項",
    "plug_title": "{{home}} · {{name}}因過載已關閉",
    "plug_rated": "{{time}} 用電 {{w}}，超過插座上限 {{limit}} · 現在 0 W",
    "plug_user": "{{time}} 用電 {{w}}，超過設定的上限 {{limit}} · 現在 0 W",
    "poe_title_high": "{{home}} · {{name}} 的 PoE 供電超過異常門檻（{{pct}}%）",
    "poe_title_warn": "{{home}} · {{name}} 的 PoE 供電超過注意門檻（{{pct}}%）",
    "poe_detail": "已配置 {{alloc}} / {{rated}}（{{pct}}%）· 實際 {{used}}",
    "poe_more_cam": "再接新攝影機可能不供電",
    "poe_incident": "這個$t(translation:leaf.cur)開了 IT 監控，已開事故",
    "home_unavailable": "{{home}}讀不到 {{h}} 小時（{{since}} 起）",
    "home_unavailable_d": "Station 與插座都離線；這段的用電沒有計入",
    "gap_title": "{{n}} 個量測點讀不到超過 {{h}} 小時",
    "gap_detail": "{{list}}；設備在線，但沒有回報用電",
    "gap_item": "{{home}} {{n}} 個",
    "act_device": "看設備",
    "act_incident": "看事故",
    "act_poe": "看供電",
    "act_home": "看$t(translation:leaf.cur)",
    "act_which": "看是哪些"
  },
  "card": {
    "energy": "本月到今天用電",
    "energy_period": "{{period}}用電",
    "cmp_prev_month": "比上月同期",
    "cmp_prev": "比上期同期",
    "cmp_basis": "同樣 {{homes}} 個$t(translation:leaf.cur)、{{meters}} 個量測點比較",
    "cmp_excluded": "{{list}}未計入比較",
    "cmp_ex_new": "{{home}}（新增量測點）",
    "cmp_ex_cov": "{{home}}（上個月同期資料不到 90%）",
    "cmp_ex_other": "{{home}}",
    "cmp_none": "不比較：{{why}}",
    "incomplete": "{{meters}} 個量測點資料不完整（共缺 {{hours}} 小時）",
    "forecast": "整月預估 {{v}}",
    "cost": "估算電費",
    "cost_homes": "{{n}} 個$t(translation:leaf.cur)",
    "cost_more": "{{n}} 種幣別",
    "cost_note": "不同幣別分開列、不換匯 · 不含基本電費",
    "cost_disclaimer": "估算值，不能作為收費或分攤依據",
    "no_tariff": "{{n}} 個$t(translation:leaf.cur)沒設電價，未計入",
    "no_tariff_any": "還沒設定電價",
    "set_tariff": "設定電價",
    "carbon": "碳排放",
    "carbon_note": "{{region}}{{provisional}}{{year}} 年{{source}}係數",
    "carbon_provisional": "暫用 ",
    "carbon_co2only": "（只有 CO2）",
    "carbon_ref": "僅供營運參考",
    "poe_note": "PoE 供電量不含 Station 本體與電源轉換損耗。",
    "visible_only": "只計入你能看用電的 {{visible}} 個$t(translation:leaf.cur)（範圍內共 {{total}} 個）",
    "unavailable_homes": "{{n}} 個$t(translation:leaf.cur)讀不到，未計入"
  },
  "trend": {
    "title_day": "趨勢 · 今天每小時用電",
    "title_month": "趨勢 · 每日用電",
    "title_year": "趨勢 · 每月用電",
    "day": "日",
    "month": "月",
    "year": "年",
    "granularity": "趨勢的期間",
    "by_kind": "依種類",
    "total_only": "合計",
    "compare": "比較$t(translation:leaf.cur)…",
    "compare_n": "比較$t(translation:leaf.cur)（{{n}}）",
    "compare_title": "選最多 5 個$t(translation:leaf.cur)比較",
    "compare_done": "比較",
    "compare_clear": "取消比較",
    "compare_max": "最多 5 個",
    "daily_total": "每日合計",
    "today_live": "今天（進行中，到 {{time}}）"
  },
  "table": {
    "by_home": "依$t(translation:leaf.cur)",
    "by_org": "依組織",
    "sort_hint": "依「比上月」由多到少；不符合比較條件的寫「—」，點「—」看原因，排在最後。",
    "sort_cmp": "比上月",
    "sort_energy": "用電量",
    "col_home": "$t(translation:leaf.cur)",
    "col_org": "組織",
    "col_kwh": "本月 kWh",
    "col_period_kwh": "本期 kWh",
    "col_cmp": "比上月",
    "col_cmp_period": "比上期",
    "col_daily": "每日平均",
    "col_cost": "估算電費",
    "col_meters": "量測點",
    "col_unavail": "讀不到（量測點）",
    "col_carbon": "碳排放",
    "no_tariff": "未設定電價",
    "more": "另有 {{n}} 個$t(translation:leaf.cur)",
    "show_all": "看全部 {{n}} 個",
    "cross_currency": "跨幣別不排序",
    "homes_count": "{{n}} 個$t(translation:leaf.cur)",
    "m2": "比上月 {{cmp}} · {{cost}} · 讀不到 {{n}} 個量測點",
    "m2_ok": "比上月 {{cmp}} · {{cost}}",
    "unavailable": "讀不到"
  },
  "ups": {
    "title": "不斷電系統",
    "line_ok": "{{n}} 台 UPS · 都用市電",
    "line_battery": "{{n}} 台 UPS · {{b}} 台用電池中 · 最短可撐 {{rt}}",
    "line_battery_unk": "{{n}} 台 UPS · {{b}} 台用電池中 · 剩餘時間讀不到",
    "unreadable": "{{n}} 台讀不到",
    "minutes": "{{n}} 分鐘",
    "note": "UPS 的輸出用電量的是另一組設備，不加進上面的總數。",
    "go": "到 IT 監控看",
    "load_err": "讀不到 UPS 狀態"
  },
  "rank": {
    "by_device": "依設備",
    "by_port": "依 PoE 孔",
    "group": "排行方式",
    "kinds": "種類",
    "all_homes": "全部$t(translation:leaf.cur)",
    "search": "找設備或$t(translation:leaf.cur)",
    "export": "匯出 CSV",
    "col_name": "名稱",
    "col_kind": "種類",
    "col_kwh": "本期 kWh",
    "col_avg": "平均功率",
    "col_max": "最高功率",
    "col_cost": "估算電費",
    "col_cmp": "比上期",
    "col_mode": "功耗模式",
    "col_pick": "選取",
    "pick_all": "全選這頁可以設定的攝影機",
    "pick_row": "選取 {{name}}",
    "no_control": "你沒有這台的控制權限，不能設定功耗模式",
    "mode_changed": "{{date}} 改「{{mode}}」",
    "mode_effect": "{{date}} 改「{{mode}}」· 前後各 {{days}} 天{{cmp}}",
    "footer": "第 {{from}}–{{to}} 名，共 {{total}} 個量測點",
    "footer_filtered": "篩選「{{f}}」· 第 {{from}}–{{to}} 名，共 {{total}} 個量測點",
    "next": "下一頁",
    "prev": "上一頁",
    "empty": "這段期間沒有用電資料",
    "filters": "排序與篩選",
    "close": "關閉",
    "show": "顯示 {{n}} 個",
    "sort": "排序",
    "sort_kwh": "用電量多到少",
    "sort_avg": "平均功率高到低",
    "sort_max": "最高功率高到低",
    "sort_cmp": "比上期多到少",
    "by_station": "{{home}} · {{station}}",
    "csv_name": "用電排行"
  },
  "pm": {
    "0": "畫質優先",
    "1": "平衡",
    "2": "省電優先",
    "picked": "已選 {{n}} 支攝影機",
    "why": "省的是電費；PoE 已配置依等級預留，改功耗模式不會降低已配置。每台各自檢查權限。",
    "clear": "取消選取",
    "set": "設定功耗模式…",
    "dlg_title": "把 {{n}} 支攝影機改成…",
    "dlg_saving": "省的是電費：依最近 7 天推估，每月約少 {{v}}",
    "dlg_alloc": "改功耗模式不會降低 PoE 已配置；要騰預算請改用較低 PoE 等級的攝影機或分到別台 Station。",
    "dlg_affects": "會影響：{{names}}",
    "dlg_quality": "「省電優先」夜間補光與畫質可能降低。",
    "dlg_ok": "套用到 {{n}} 支",
    "dlg_cancel": "取消",
    "result_title": "功耗模式結果",
    "result_summary": "{{applied}} 支已套用、{{pending}} 支等待設備套用",
    "result_failed": "{{n}} 支沒有套用",
    "st_applied": "✓ 已套用",
    "st_pending": "⟳ 等待設備套用",
    "st_failed": "✕ 設備沒有套用",
    "st_forbidden": "✕ 沒有控制權限",
    "deadline": "最晚 {{time}} 知道結果；到時還沒套用會改成「設備沒有套用」",
    "retry": "重試",
    "done": "完成",
    "err": "設定失敗：{{msg}}"
  },
  "report": {
    "month": "月份",
    "month_opt": "{{y}} 年 {{m}} 月",
    "opt_provisional": "（暫定）",
    "opt_final": "（已定案）",
    "provisional": "暫定：設備補報的資料可能讓數字再變動，{{date}}定案",
    "final": "已定案",
    "date_md": "{{m}} 月 {{d}} 日",
    "scope_total": "範圍合計",
    "gaps": "缺 {{hours}} 小時（{{meters}} 個量測點）",
    "no_gaps": "沒有缺口",
    "summary_by": "依$t(translation:leaf.cur)摘要",
    "only_gaps": "只看有缺口的（{{n}}）",
    "has_gap": "! 有缺口",
    "expand": "展開 {{home}} 的量測點",
    "top": "前 10 名",
    "rounding": "各列四捨五入顯示，合計依未四捨五入的值計算（CSV 保留兩位小數）",
    "csv_homes": "下載 CSV（逐$t(translation:leaf.cur) × 逐日）",
    "csv_meters": "下載 CSV（逐量測點 × 逐月）",
    "csv_prefix": "用電",
    "provisional_tag": "暫定",
    "carbon_basis": "{{gas}} · {{year}} 年係數",
    "pdf_later": "PDF 與每月寄送之後提供"
  },
  "csv": {
    "disclaimer": "估算值，不能作為收費或分攤依據",
    "date": "日期",
    "month": "月份",
    "home": "$t(translation:leaf.cur)",
    "org": "組織",
    "meter_name": "量測點",
    "meter_kind": "種類",
    "kwh": "用電（kWh）",
    "avg_w": "平均功率（W）",
    "max_w": "最高功率（W）",
    "cost": "估算電費（{{cur}}）",
    "currency": "幣別",
    "cost_amount": "估算電費",
    "quality": "資料品質（實測 / 補估 / 沒有資料）",
    "missing_h": "缺的小時",
    "carbon": "碳排放（kg）",
    "carbon_basis": "碳排口徑"
  },
  "org": {
    "card_title": "電價與碳排",
    "card_hint": "{{n}} 個電價方案 · 套用到$t(translation:leaf.cur)後估算電費",
    "manage": "管理電價",
    "title": "電價",
    "crumb": "組織設定",
    "hint": "電價方案套用到$t(translation:leaf.cur)後，用電頁才算得出估算電費。建議：同電價的$t(translation:leaf.cur)用〔套用到$t(translation:leaf.cur)…〕併到同一個方案、之後只維護一個；要保留名稱與版本紀錄才用〔改用新版…〕。",
    "no_admin": "只有組織擁有者或組織管理員能管理電價",
    "col_name": "方案",
    "col_kind": "類型",
    "col_currency": "幣別",
    "col_applied": "套用到",
    "col_version": "目前版本",
    "applied_n": "{{n}} 個$t(translation:leaf.cur)",
    "version_from": "v{{v}} · {{date}} 起",
    "kind_flat": "單一單價",
    "kind_tiered": "累進級距",
    "kind_tou": "時間電價",
    "add": "新增方案",
    "apply": "套用到$t(translation:leaf.cur)…",
    "new_version": "改用新版…",
    "delete": "刪除",
    "delete_confirm": "刪除「{{name}}」？",
    "in_use": "還有 {{n}} 個$t(translation:leaf.cur)在用這個方案，先把它們改用別的方案再刪",
    "empty": "還沒有電價方案",
    "carbon_title": "碳排",
    "show_carbon": "在用電總覽顯示碳排卡",
    "carbon_category": "排碳係數類別",
    "cat_grid": "電網平均（依地區與年度）",
    "saved": "✓ 已儲存",
    "recalc": "重算中，約 1 分鐘",
    "no_rates": "看不到單價（只有$t(translation:leaf.cur)擁有者 / 管理員與組織管理員看得到）"
  },
  "ed": {
    "title": "新增電價方案",
    "from_template": "從範本",
    "custom": "自訂",
    "template": "範本",
    "template_note": "範本的單價照官方公告；寫進前會對原文，畫面上的數字只是起點，可以改。",
    "name": "方案名稱",
    "kind": "類型",
    "currency": "幣別",
    "effective": "生效日",
    "effective_hint": "預設這個月 1 日；最多追溯 30 天；選到已定案的月份不會重算",
    "flat_price": "每度單價",
    "tier": "第 {{n}} 級",
    "tier_upto": "每月 {{v}} 度以下",
    "tier_rest": "以上",
    "tou_period": "{{name}}（{{days}} {{from}}–{{to}} 時）",
    "days_weekday": "週一至週五",
    "days_weekend": "週末與假日",
    "days_all": "每天",
    "per_kwh": "{{cur}} / 度",
    "save": "建立方案",
    "cancel": "取消",
    "err_name": "方案名稱必填",
    "err_price": "單價要是 0 以上的數字",
    "version_title": "「{{name}}」改用新版",
    "version_save": "加新版本"
  },
  "apply": {
    "title": "把「{{name}}」套用到$t(translation:leaf.cur)",
    "filter_old": "目前用舊方案（{{n}}）",
    "filter_none": "沒設電價（{{n}}）",
    "filter_all": "全部（{{n}}）",
    "shown": "顯示 {{n}} 個$t(translation:leaf.cur)",
    "hidden": "另 {{n}} 個不符合",
    "clear_filter": "清除篩選",
    "current": "目前：{{name}}",
    "current_none": "目前：沒設電價",
    "already": "已經是這個方案",
    "currency_diff": "幣別不同（{{cur}}），不能套用",
    "pick_all": "全選「{{group}}」",
    "next": "套用到 {{n}} 個$t(translation:leaf.cur)…",
    "confirm_title": "把「{{name}}」套用到 {{n}} 個$t(translation:leaf.cur)",
    "confirm_body": "這 {{n}} 個$t(translation:leaf.cur) {{date}}起的估算電費會用新方案重算；已下載的報表不會跟著改。",
    "confirm_old": "其中 {{n}} 個原本用「{{old}}」。",
    "final_warn": "{{month}} 已定案，不會重算",
    "ok": "套用",
    "done": "已套用到 {{n}} 個$t(translation:leaf.cur)",
    "done_one": "已套用",
    "undo": "復原",
    "none_picked": "先勾要套用的$t(translation:leaf.cur)"
  },
  "leaf": {
    "title": "用電設定",
    "crumb_sites": "組織與場域",
    "locked": "只有擁有者或管理員能修改",
    "tariff": "電價",
    "tariff_org": "沿用：{{name}}",
    "tariff_home": "{{name}}（這個$t(translation:leaf.cur)自己設的）",
    "tariff_none": "還沒設定電價",
    "tariff_pick": "改選",
    "tariff_none_opt": "不設電價（電費不計入）",
    "tariff_custom": "自訂…（到組織設定 › 電價）",
    "alerts": "用電提醒",
    "poe": "PoE 供電",
    "poe_desc": "超過 Station 額定的這個比例時提醒",
    "poe_warn": "注意",
    "poe_high": "異常",
    "pct": "%",
    "gap": "讀不到資料",
    "gap_desc": "設備在線、超過這麼多小時沒有回報用電就提醒",
    "hours": "小時",
    "kmgr_on": "這個$t(translation:leaf.cur)開了 IT 監控：超過門檻會開事故、照輪值表通知",
    "kmgr_off": "超過門檻會通知$t(translation:leaf.cur)的擁有者與管理員（只進收件匣）",
    "managed": "由範本「{{name}}」管理",
    "unmanage": "解除範本管理",
    "unmanage_confirm": "解除後這裡的門檻可以自己改，範本之後的變更不再套到這個$t(translation:leaf.cur)。",
    "saved": "✓ 已儲存",
    "saving": "儲存中…",
    "err_range": "要是 {{min}}–{{max}} 的整數",
    "err_order": "注意門檻不能高於異常門檻",
    "pick_title": "選擇$t(translation:leaf.cur)",
    "not_found": "找不到這個$t(translation:leaf.cur)，或你沒有它的權限",
    "to_overview": "看這個$t(translation:leaf.cur)的用電"
  },
  "dev": {
    "title": "用電",
    "now": "現在",
    "today": "今天",
    "month": "本月到今天",
    "cost": "估算電費",
    "via_poe": "由 PoE 供電量測（{{station}} 第 {{port}} 孔）",
    "range_day": "日",
    "range_week": "週",
    "range_month": "月",
    "chart_day": "最近 24 小時每小時用電",
    "chart_week": "最近 7 天每日用電",
    "chart_month": "最近 30 天每日用電",
    "export": "匯出 CSV",
    "no_data": "還沒有用電資料",
    "load_err": "用電資料讀不到",
    "mode_mark": "{{date}} 改「{{mode}}」"
  },
  "stn": {
    "budget": "PoE 供電：已配置 {{alloc}} / {{rated}} · 實際 {{used}}",
    "budget_norated": "PoE 供電：目前供電 {{used}}",
    "alloc_note": "已配置比現在實際多 {{diff}}：PoE 依等級預留，改攝影機的功耗模式只省電費，不會降低已配置。",
    "col_today": "今天",
    "col_24h": "24 小時",
    "today": "今天 {{v}}",
    "spark": "第 {{port}} 孔最近 24 小時供電",
    "expand": "看第 {{port}} 孔 7 天曲線",
    "collapse": "收起",
    "week_title": "第 {{port}} 孔 · 最近 7 天每小時供電",
    "no_detail": "這台 Station 沒有回報 PoE 供電明細",
    "load_err": "供電資料讀不到",
    "unknown": "不知道",
    "budget_noalloc": "PoE 供電：額定 {{rated}} · 實際 {{used}}",
    "col_energy": "用電"
  },
  "syn": {
    "energy": "用電,電費,電價,功率,kWh,度,碳排,PoE,耗電,省電",
    "org_tariffs": "電價,電費,費率,碳排係數",
    "leaf_settings": "用電設定,用電提醒,PoE 門檻,電價",
    "ups": "UPS,不斷電,不斷電系統,停電,電池供電,PoE"
  },
  "search": {
    "leaf_settings": "$t(translation:leaf.cur)的用電設定（先選$t(translation:leaf.cur)）",
    "ups": "網路與應用 · 不斷電系統（UPS）"
  },
  "err": {
    "ENERGY_RANGE_TOO_LARGE": "期間太長，請縮短後再試",
    "ENERGY_TARIFF_INVALID": "電價方案不正確：{{reason}}",
    "ENERGY_TARIFF_IN_USE": "還有$t(translation:leaf.cur)在用這個方案",
    "FORBIDDEN": "你沒有權限",
    "VERSION_CONFLICT": "別人剛改過，重新整理後再改",
    "NOT_FOUND": "用電 API 還沒有這個資料",
    "other": "發生錯誤（{{code}}）",
    "copy": "複製給客服",
    "details": "詳細"
  },
  "loading": "讀取中…"
}
